import { useEffect, useState } from 'react';
import api from '../../api';
import AVIcon from '../../components/icons/AllVoicedIcons';
import ParticipantExperienceCard from './ParticipantExperienceCard';
import './SelectedParticipantExperiences.css';

export const SELECTED_EXPERIENCES_HEADING =
  'Experiences from the All-Voiced community';

export const SELECTED_EXPERIENCES_INTRO =
  'A small selection of experiences that All-Voiced participants chose to share publicly.';

export const SELECTED_EXPERIENCES_VERIFICATION_EXPLANATION =
  'Experiences shown here were submitted by authenticated, email-verified All-Voiced accounts after completing at least one qualifying All-Voiced activity. This does not mean that All-Voiced has verified the person’s identity, profession, institution, credentials, opinion, claims, or endorsement.';

const loadSelectedExperiences = async () =>
  (await api.get('/public/community-experiences')).data;

export default function SelectedParticipantExperiences({
  load = loadSelectedExperiences,
}) {
  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    let active = true;

    load()
      .then((result) => {
        if (active) {
          setExperiences((result?.experiences || []).slice(0, 3));
        }
      })
      .catch(() => {
        if (active) {
          setExperiences([]);
        }
      });

    return () => {
      active = false;
    };
  }, [load]);

  if (!experiences.length) {
    return null;
  }

  return (
    <section
      aria-labelledby="selected-participant-experiences-title"
      className="selected-experiences"
    >
      <div className="selected-experiences__content">
        <header className="selected-experiences__heading">
          <div className="selected-experiences__title-row">
            <h2 id="selected-participant-experiences-title">
              {SELECTED_EXPERIENCES_HEADING}
            </h2>

            <details className="selected-experiences__information">
              <summary
                aria-label="About these experiences"
                title="About these experiences"
              >
                <AVIcon
                  aria-hidden="true"
                  focusable="false"
                  icon="info"
                  size={20}
                />
              </summary>

              <div className="selected-experiences__information-panel">
                <p className="selected-experiences__information-title">
                  About these experiences
                </p>

                <p>{SELECTED_EXPERIENCES_VERIFICATION_EXPLANATION}</p>
              </div>
            </details>
          </div>

          <p className="selected-experiences__intro">
            {SELECTED_EXPERIENCES_INTRO}
          </p>
        </header>

        <div
          className={`selected-experiences__grid selected-experiences__grid--count-${experiences.length}`}
        >
          {experiences.map((experience, index) => (
            <ParticipantExperienceCard
              collapsible
              identity={experience.identity}
              key={`${index}:${experience.text}`}
              text={experience.text}
            />
          ))}
        </div>
      </div>
    </section>
  );
}